<template>
    <div class="container-fluid min-vh-100 d-flex justify-content-center align-items-center" style="background-color: hwb(180 20% 79%)">
      <div class=" col-md-3">
        <div class="card custom-card">
          <div class="card-body">

            <!-- Logo tipo -->
            <div class="card-login p-5 text-center">
              <img :src="`/img/svg/Logo_Grupo_Mass.svg`" alt="Logo de la empresa" class="img-fluid">
            </div>
            <br>
            <!--<h3 class="text-center mb-4">Iniciar Sesión</h3>-->
            <form @submit.prevent="login">
              <label for="userName" class="form-label py-2">Nombre de Usuario</label>
              <div class="mt-1 input-group">
                <input
                  type="text"
                  id="userName"
                  v-model="form.username"
                  class="form-control"
                  autocomplete="current-userName"
                />
  
              </div>
              <div class="mt-1">
                <label for="password" class="form-label py-2">Contraseña</label>
                <input
                  type="password"
                  id="password"
                  class="form-control"
                  v-model="form.password"
                  autocomplete="current-password"
                />
              </div>
              <div class="col-md-12 pt-4 mb-3 center">
                <button type="submit" class="form-control btn btn-block btn-custom">
                  Iniciar Sesión
                </button>
              </div>
            </form>

            <div v-if="errors.length" class="alert alert-danger mt-3">
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error.mensaje }}
                </li>
              </ul>
            </div>
            <div v-if="successMessage" class="alert alert-success mt-3">
              {{ successMessage }}
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  import { ref } from "vue";
  import router from '../../router'
  import api from "../../apis/User"
  import axiosConfig from "../../axios-config"
  import { handleError } from "../../Utils/StatusHandler"

  export default {
    name: "LoginView",

    setup() {
      const form = ref({
        username: "",
        password: "",
      });

      const errors = ref([]);
      const successMessage = ref("");
      
      const handleErrors = (error) => {
        handleError(error, { errors });
      };


      const login = async () => {
        errors.value = [];

        try {
          const response = await api.postLogin(form.value);

          if (response) {
            if (response.status === 200 && response.data.success === true) {
              const responseData = response.data.data;
              const rolData = responseData.roles[0]?.id;
              const { username, token } = responseData;
              localStorage.setItem("username", username);
              localStorage.setItem("token", token);
              localStorage.setItem("rol", rolData);
  
              axiosConfig();
  
              router.push({ name: "ListCompanies" });
              successMessage.value = "Inicio de sesión exitoso.";
            }
          }
        } catch (error) {
          console.error(error);
          handleErrors(error, this);
        }
      };
      return {
        form,
        errors,
        successMessage,
        // urlBase,
        login,
      };
    },
  };
</script>